// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss, xScreen } from "@pacific/XDL/Utilities";
import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: CheckoutHeaderItemStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    const totalCartItems = getCurrentCartState(state).value?.totalCountDisplay;
    return {
        totalCartItems: typeof totalCartItems === "undefined" ? 0 : totalCartItems || 0,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CheckoutHeaderItemStyles {
    wrapper?: InjectableCss;
    label?: TypographyProps;
    count?: TypographyProps;
}

const labelSharedStyles: TypographyProps = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

export const checkoutHeaderItemStyles: CheckoutHeaderItemStyles = {
    wrapper: {
        css: css`
            display: flex;
            gap: 4px;
            margin-left: auto;
            ${xScreen("lte", "352")} {
                margin-left: 0;
                margin-top: 16px;
            }
        `,
    },
    label: {
        ...labelSharedStyles,
    },
    count: {
        ...labelSharedStyles,
    },
};

const CheckoutHeaderItem = ({ totalCartItems, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeWithCss(checkoutHeaderItemStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.label}>{translate("Checkout")}</Typography>
            <Typography {...styles.count}>
                {translate(`({0} Item{1})`, totalCartItems.toString(), totalCartItems > 1 ? "s" : "")}
            </Typography>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(CheckoutHeaderItem);
